import { useLocalization } from 'redux/localization/utils/hooks';

import ProductLink from '../ProductLink';

import Picture from './common/Picture';

const ListImage = (props) => {
  const { linkType, image, size, product } = props;
  const { t } = useLocalization();

  switch (linkType) {
    case 'None': {
      return <Picture image={image} alt={product.title} size={size} />;
    }
    case 'Ajax':
    case 'Window': {
      return (
        <ProductLink linkType={linkType} product={product}>
          <Picture image={image} alt={product.title} size={size} />
        </ProductLink>
      );
    }
    default: {
      return t('general.errorMessages.invalidProductLinkType');
    }
  }
};

export default ListImage;
